// biome-ignore format: historic
// biome-ignore format: historic
// biome-ignore format: historic
import { LockableTextField } from '@components/Card2/LockableTextField';
import { Stack } from '@ui-lib';
import type { FormEvent } from 'react';

import SuggestionsSection, { useSuggestionsSection } from '../SuggestionsSection/SuggestionsSection';

interface LabelFieldProps {
  label: string;
  labelLocked: boolean;
  setLabel: (value: string) => void;
  setLabelLocked?: (value: boolean) => void;
  labelSuggestions: string[];
  labelLockedByTemplate?: boolean;
  required?: boolean;
  /** What do you want this label to be referred to as, a Title or a Label? */
  subject?: 'title' | 'label';
}

export function LabelField({
  label,
  labelLocked,
  setLabel,
  setLabelLocked,
  labelSuggestions,
  labelLockedByTemplate,
  required = false,
  subject = 'label',
}: LabelFieldProps): React.ReactElement {
  const [selectedOption, setSelectedOption] = useSuggestionsSection(labelSuggestions, label);

  function handleSelectSuggestion(suggestion: string) {
    const newSelectedOption = suggestion === selectedOption ? '' : suggestion;
    setSelectedOption(newSelectedOption);
    setLabel(newSelectedOption);
  }

  const handleChange = (event: FormEvent<HTMLInputElement>) => setLabel(event.currentTarget.value);

  let inputLabel = subject === 'title' ? 'Title' : 'Label';
  inputLabel = required ? inputLabel : `${inputLabel} (Optional)`;

  return (
    <Stack gap="small">
      <LockableTextField
        value={label}
        onChange={handleChange}
        label={inputLabel}
        locked={labelLocked}
        toggleLocked={setLabelLocked ? () => setLabelLocked(!labelLocked) : undefined}
        explanation={labelLockedByTemplate ? 'Locked by template' : undefined}
        required={required}
      />
      {!labelLocked && labelSuggestions?.length > 0 && (
        <SuggestionsSection
          options={labelSuggestions}
          onSelect={handleSelectSuggestion}
          selectedOption={selectedOption}
          subject={subject}
        />
      )}
    </Stack>
  );
}
